export default () => {

    const buttonWrapper = document.querySelector('.hamburger__wrapper');
    const navigation = document.querySelector('.navigation');
    const button = document.querySelector('.hamburger');


    buttonWrapper.addEventListener('click', () => {
        const winWidth = window.innerWidth

        button.classList.toggle('active')
        navigation.classList.toggle('active')
        buttonWrapper.classList.toggle('active')

        // if (winWidth <= 480) {
        //     document.body.classList.toggle('menu-active')
        // }
    })



    const sections = document.querySelectorAll('section[id]')
    const menuItems = document.querySelectorAll('.navigation-item')

    window.addEventListener('scroll', autoHighlight)

    function autoHighlight() {
        sections.forEach(section => {

            var topOffset = section.offsetTop - 120,

                bottomPosition = topOffset + section.clientHeight,
                scrollPosition = window.scrollY,
                elId = section.getAttribute('id');


            if (scrollPosition > topOffset && scrollPosition < bottomPosition) {
                menuItems.forEach(item => {
                    item.classList.remove('active')
                });
                [...menuItems].find(btn => btn.href.split('#')[1] === elId).classList.add('active')
            }
        })
    }

    window.addEventListener('resize', mobileMenu)
    window.addEventListener('load', mobileMenu)

    function mobileMenu() {

        const winWidth = window.innerWidth
        if (winWidth <= 480){

            document.querySelector('.headeer__btn--inner').addEventListener('click', function (){
                navigation.classList.remove('active');
                button.classList.remove('active');
                // document.body.classList.remove('menu-active')
            })

            menuItems.forEach(menuItem => {

                menuItem.addEventListener('click', function () {

                    navigation.classList.remove('active');
                    button.classList.remove('active');
                    // document.body.classList.remove('menu-active')
                })
            })
        }
    }



    function setMenuPosition() {
        const container = document.querySelector('.container')
        const menuWind = document.querySelector('.navigation')

        window.addEventListener('resize', setLeftPosition)

        function setLeftPosition() {
            const winWidth = window.innerWidth


            if (winWidth > 1760) {
                // console.log(`${(winWidth - container.clientWidth) / 2}px`)
                menuWind.style.maxWidth = `${(winWidth - container.clientWidth) / 2}px`
            } else {
                menuWind.style.maxWidth = null
            }
        }
        setLeftPosition()
    }
    setMenuPosition()

}